@if (!hide && show) {
  <p class="alert-danger">
    <i class="icon-cnt-times-circle"></i>
    @if (field) {
      <span class="font-weight-bold">{{ field }}:</span>
    }
    {{ _text }}
  </p>
}
